import { useEffect, useState } from "react";  
import { GetHomeAboutSection } from "../data/HomeAboutController";

export const UseHomeAbout = () => { 
  const [HomAbout, setHomAbout] = useState([]);
  useEffect(() => {
    const func = async () => {
      try {
        const GetData = await GetHomeAboutSection();
        setHomAbout(GetData);
    } catch (error) {
        console.log(error);
      }
    };

    func();
  }, []);

  return HomAbout;
};
